import { render } from "./CollageTile.vue?vue&type=template&id=68a41bfe&ts=true"
import script from "./CollageTile.vue?vue&type=script&lang=ts"
export * from "./CollageTile.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__